import { Link, type ErrorComponentProps } from '@tanstack/react-router';
import { Button, EmptyState, ErrorState } from '@salesbee/ui';

export function RootErrorPage({ error, reset }: ErrorComponentProps) {
  return (
    <div className="mx-auto max-w-xl p-8">
      <ErrorState error={error} onRetry={reset} />
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className="mx-auto max-w-xl p-8">
      <EmptyState
        title="Page not found"
        description="The page you are looking for does not exist or was moved."
        action={
          <Button asChild variant="outline">
            <Link to="/">Go home</Link>
          </Button>
        }
      />
    </div>
  );
}
